var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"queue-card"},[_vm._m(0),_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("互动区")]),_c('queue-info',{attrs:{"exhibitId":_vm.exhibitId}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('img',{attrs:{"src":require("assets/queue-int.png")}})])
}]

export { render, staticRenderFns }